import { render, staticRenderFns } from "./SettlementDriverView.vue?vue&type=template&id=2b49ef3e"
import script from "./SettlementDriverView.vue?vue&type=script&lang=js"
export * from "./SettlementDriverView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports